import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchVendorMasterAPI } from '../../../api/commonApi';

export const fetchVendorMaster = createAsyncThunk(
  'vendor/fetchVendors',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchVendorMasterAPI();
      return response.venderMasterData;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// import { fetchVendorMaster } from '../../reducetool/features/vendor/vendorThunks';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchBranchMaster } from '../../reducetool/features/branch/branchThunks';


//  const dispatch = useDispatch();
//     // Vendors already loaded in global state on login
//     const vendors = useSelector((state) => state.vendorState);
//     const branches = useSelector((state) => state.branchState);
//     const loading = useSelector((state) => state.branchState.loading);
//     const error = useSelector((state) => state.branchState.error);

//     console.log(vendors, "vendors ___________@@@@@@@@@@@@@@@")
//     console.log(branches, "branches ___________@@@@@@@@@@@@@@@")
//     console.log(loading, "loading ___________@@@@@@@@@@@@@@@")
//     console.log(error, "error ___________@@@@@@@@@@@@@@@")
//     useEffect(() => {
//         dispatch(fetchBranchMaster(1));
//         dispatch(fetchVendorMaster());

//     }, []);

//  ====================== frontent ====================
  
{/* <div>
  <h2>Branch List</h2>
  {loading && <p>Loading...</p>}
  {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
  <ul>
    {branches?.map((branch) => (
      <li key={branch.id}>{branch.name}</li>
    ))}
  </ul>
</div> */}